module.exports = __webpack_public_path__ + "img/mugualogo.0f6ff0e2.png";